module.exports = __webpack_public_path__ + "media/images/favicon/favicon-72-dd9d620534d5699edbe4a2d46377a710.png";